import { Component, OnInit } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PaymentBookingRequest, PaymentIntent } from './payment.models';
import { PaymentLibService } from './payment-lib.service';
import { Ticket } from 'core-lib';

@Component({
    selector: 'lib-payment-lib',
    templateUrl: './payment-lib.component.html',
    styleUrls: ['./payment-lib.component.scss'],
    standalone: false
})
export class PaymentLibComponent implements OnInit {

  intent: PaymentIntent;
  paymentComplete = false;


  viewControl = {
    shoppingCartView: {
      visible: false
    },
    bookingView: {
      visible: false
    },
    walletView: {
      visible: false
    }
  }

  constructor(public dialogRef: DynamicDialogRef, private dialogConfig: DynamicDialogConfig, private paymentService: PaymentLibService) {
    this.intent = this.dialogConfig.data;
  }

  ngOnInit(): void {
    this.paymentService.loadWallet().subscribe((allWalletElements) => {
      const matchingResults = allWalletElements.filter((el: Ticket) => this.intent.productDefinitionIds.indexOf(el.product.id) > -1)
      if (matchingResults.length == 0){
        this.viewControl.shoppingCartView.visible = true;
      }else{
        this.viewControl.bookingView.visible = true;
      }
    });

  }

  onBook(bookingRequests: PaymentBookingRequest[]): void {
    this.dialogRef.close(bookingRequests);
  }

  onChangeView(view: string): void {
    this.viewControl.bookingView.visible = false;
    this.viewControl.walletView.visible = false;
    this.viewControl.shoppingCartView.visible = false;

    switch (view) {
      case 'shop':
        this.viewControl.shoppingCartView.visible = true;
        break;
      case 'wallet':
        this.viewControl.walletView.visible = true;
        break;
      case 'booking':
        this.viewControl.bookingView.visible = true;
        break;
    }
  }

  static initPaymentInDialog(dialogService: DialogService, intent: PaymentIntent): DynamicDialogRef {
    return dialogService.open(PaymentLibComponent, {
      width: '90%',
      focusOnShow: false,
      height: '100%',
      modal: true,
      data: intent
    })
  }
}
